import { ObjectFactory } from '@/config/objectFactory';
import { HealthcareProvider } from '@/types/entity';
import { ApiRequest, QueryRecordsRequest } from '@/types/request';
import { ApiResponse } from '@/types/response';
import { CommonUtils } from '@/util/commonUtils';
import { MedTransGoConstants } from '@/util/constants';
import { IProviderService } from '../iProviderService';

export class ProviderService implements IProviderService {
    public async getHealthcareProviders(baseURL: string, searchString?: string, start?: number, limit?: number,
                                        locationIds?: string[]): Promise<ApiResponse<HealthcareProvider[]>> {
        const iHttpService = ObjectFactory.getHttpService();
        const queryRecordsRequest: QueryRecordsRequest = {
            limit: limit ? limit : MedTransGoConstants.PAGINATION_LIMIT,
            start,
            conditions: [],
            op: 'and',
        };
        if (locationIds && locationIds.length > 0 && queryRecordsRequest.conditions) {
            queryRecordsRequest.conditions.push({
                op: 'in',
                fieldName: 'billingLocationId',
                value: locationIds,
            });
        }
        const apiRequest: ApiRequest = {
            baseURL,
            data: queryRecordsRequest,
            url: `${MedTransGoConstants.HTTP_URL_PROVIDERS}/list`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<HealthcareProvider[]>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }

    public async getProviderDetails(baseURL: string, providerId: string):
        Promise<ApiResponse<any>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_PROVIDERS}/${providerId}`,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.get<HealthcareProvider>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }

    public async updateProvider(baseURL: string, providerId: string, updateProviderRequest: HealthcareProvider):
        Promise<ApiResponse<any>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL,
            loaderEvent: {
                show: true,
            },
            data: updateProviderRequest,
            url: `${MedTransGoConstants.HTTP_URL_PROVIDERS}/${providerId}`,
        };
        const response = await iHttpService.put<any>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }

    public async addProvider(baseURL: string, addProviderRequest: HealthcareProvider): Promise<ApiResponse<any>> {
        const iHttpService = ObjectFactory.getHttpService();
        const apiRequest: ApiRequest = {
            baseURL,
            url: `${MedTransGoConstants.HTTP_URL_PROVIDERS}`,
            data: addProviderRequest,
            loaderEvent: {
                show: true,
            },
        };
        const response = await iHttpService.post<HealthcareProvider>(apiRequest);
        if (!response.success) {
            CommonUtils.showError(response);
        }
        return response;
    }

}
